<template>
    <div class="modal fade" id="iproxyAddModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered w-[700px]">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5">Add New Proxy (iProxy)</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body flex flex-wrap">
                    <div class="float-left w-full px-2 py-2 modal-item">
                        Authentication
                        <v-radio-group v-model="authType" inline class="pt-1">
                            <v-radio label="Username:Password" value="username"></v-radio>
                            <v-radio label="IP Whitelist" value="ip"></v-radio>
                        </v-radio-group>
                    </div>
                    <div class="float-left w-full px-2 py-2 modal-item" v-if="authType === 'username'">
                        Authentication User (username:password)
                        <v-text-field v-model="userAuthentication" variant="outlined" density="compact" rounded="0">
                            <template v-slot:append-inner>
                                <v-icon icon="mdi-refresh" @click="generateRandomCredentials"></v-icon>
                            </template>
                        </v-text-field>
                    </div>
                    <div class="float-left w-full px-2 py-2 modal-item" v-else>
                        Authorization IPs (comma separated)
                        <v-text-field v-model="ipAuthentication" variant="outlined" density="compact" rounded="0"
                            placeholder="1.2.3.4,5.6.7.8"></v-text-field>
                    </div>
                    <div class="float-left w-1/2 px-2 py-2 modal-item">
                        Label (optional)
                        <v-text-field v-model="label" variant="outlined" density="compact" rounded="0"></v-text-field>
                    </div>
                    <div class="float-left w-1/2 px-2 py-2 modal-item">
                        Notes (optional)
                        <v-text-field v-model="notes" variant="outlined" density="compact" rounded="0"></v-text-field>
                    </div>
                    <AdminConnectionTools :serverName="serverName" />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" :disabled="buttonDisableFlag" class="btn btn-primary" @click="createAccess">
                        Create
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import AdminConnectionTools from '../ConnectionTools.vue';
import { ref, defineEmits, defineProps, watchEffect } from 'vue';
import { useAdminProxyStore } from "@/stores";

const adminProxyStore = useAdminProxyStore();
const emit = defineEmits(['close']);
const props = defineProps({
    serverName: {
        type: String,
        required: true
    }
});

const selectedServerName = ref(props.serverName);
watchEffect(() => {
    selectedServerName.value = props.serverName;
}, [props.serverName]);

const authType = ref('username');
const userAuthentication = ref('');
const ipAuthentication = ref('');
const label = ref('');
const notes = ref('');
const buttonDisableFlag = ref(false);

function generateRandomCredentials() {
    const letters = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let u = '';
    let p = '';
    for (let i = 0; i < 7; i++) u += letters.charAt(Math.floor(Math.random() * letters.length));
    for (let i = 0; i < 7; i++) p += Math.floor(Math.random() * 10);
    userAuthentication.value = `u${u}:p${p}`;
}
generateRandomCredentials();

async function createAccess() {
    let temp_auth_user = userAuthentication.value || null;
    let temp_auth_ips = ipAuthentication.value || null;
    if (authType.value === 'username') temp_auth_ips = null;
    if (authType.value === 'ip') temp_auth_user = null;

    // Basic validation
    if (authType.value === 'username' && (!temp_auth_user || temp_auth_user.split(':').length !== 2)) {
        return;
    }

    const accessRequest = {
        auth_type: authType.value,
        userAuthentication: temp_auth_user,
        ipAuthentication: temp_auth_ips,
        label: label.value,
        notes: notes.value,
    };
    buttonDisableFlag.value = true;
    await adminProxyStore.createIProxyAccess(selectedServerName.value, accessRequest);
    buttonDisableFlag.value = false;
    emit('close');
}
</script>

<style scoped>
.modal-item {
    font-size: 12px;
}
</style>


